import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface IUserState {
  userId?: string;
  userSeq?: number;
  userToken?: string;
  userBirthDate?: Date;
  userName?: string;
  userType?: string; // '1': 사업주 '0': 매니저
  ISP?: boolean; // 마스터비밀번호 접속 여부
}
export interface IManagerState {
  empSeq: number;
  payShow: boolean; // 본인급여 표시
  storePayShow: boolean; // 사업장 급여 표시
  otherPayShow: boolean; // 타직원 정보 수정가능 여부
  calendarEdit: boolean; // 출퇴근기록 수정가능 여부
  recievePush: boolean; // 타직원 알림 허용 여부
}
export interface IUser extends IUserState {
  setUserInfo: (data: IUserState) => void;
  subscribePlanName?: string;
  setSubscribePlanName: (name: string) => void;
  managerInfo: IManagerState;
  setManagerInfo: (data: IManagerState) => void;
  setISP: (boolean: boolean) => void;
}

export const useUserStore = create<IUser>()(
  persist(
    (set, get) => ({
      userId: '',
      userSeq: 0,
      userToken: '',
      userBirthDate: new Date(),
      userName: '',
      userType: '1',
      subscribePlanName: '무료',
      managerInfo: {
        empSeq: 0,
        payShow: false, // 본인급여 표시
        storePayShow: false, // 사업장 급여 표시
        otherPayShow: false, // 타직원 정보 수정가능 여부
        calendarEdit: false, // 출퇴근기록 수정가능 여부
        recievePush: false, // 타직원 알림 허용 여부
      },
      setUserInfo: (data: IUserState) =>
        set((state) => ({
          userId: data?.userId ?? state.userId,
          userSeq: data?.userSeq ?? state.userSeq,
          userToken: data.userToken ?? state.userToken,
          userBirthDate: data.userBirthDate ?? state.userBirthDate,
          userName: data.userName ?? state.userName,
          userType: data.userType ?? state.userType,
        })),
      setSubscribePlanName: (name: string) =>
        set((state) => ({
          subscribePlanName: name ?? state.subscribePlanName,
        })),
      setManagerInfo: (data: IManagerState) =>
        set((state) => ({
          managerInfo: data ?? state.managerInfo,
        })),
      setISP: (boolean: boolean) =>
        set(() => ({
          ISP: boolean,
        })),
    }),
    {
      name: 'user-storage',
      onRehydrateStorage: (state) => {
        return (state, error) => {
          if (error) {
          } else {
          }
        };
      },
    },
  ),
);

export default useUserStore;
